import { defineStore } from 'pinia';

export const useNotificationStore = defineStore("notifications", {
  state: () => ({
    queue: []
  }),
  actions: {
    addNotification(message, type = 'info') {
      const id = Date.now() + Math.random();
      this.queue.push({ id, message, type });
      
      // Auto-dismiss after 5 seconds
      setTimeout(() => {
        this.removeNotification(id);
      }, 5000);
    },
    removeNotification(id) {
      this.queue = this.queue.filter(n => n.id !== id);
    }
  }
});
